import { nextTick } from 'alpinejs/src/nextTick'

export const startBicAutocomplete = () => {
  const loadBics = async() => {
    if (!window.storageUrl) {
      return
    }

    try {
      const res = await fetch(window.storageUrl + '/blzs.json')
      window.bics = await res.json()
    } catch (e) {
      console.error('Failed to load BICs', e)
      window.bics = {}
    }
  }

  const initBicAutocompleteElements = () => {
    document
      .querySelectorAll('.bic_autocomplete_iban input')
      .forEach((element) => {
        if (element.classList.contains('bic_autocomplete_initialized')) {
          return
        }

        const bicElementSelector = element.getAttribute('data-for-bic')
        const bicElement = document.querySelector(bicElementSelector)

        element.addEventListener('input', (event) => {
          if (!window.bics) {
            return
          }

          const iban = element.value.toUpperCase().replaceAll(' ', '')
          if (iban.startsWith('DE') && iban.length === 22) {
            const blz = iban.substring(4, 12)
            const bic = window.bics[blz] ? window.bics[blz] : null

            if (bic) {
              bicElement.value = bic
              bicElement.dispatchEvent(new Event('input', { bubbles: true }))
            }
          }
        })

        element.classList.add('bic_autocomplete_initialized')
      })
  }

  const delayBicAutocompleteElementsInit = () => {
    // double microtask necessary, because otherwise wire-binding will not work in te-select.
    queueMicrotask(() => {
      queueMicrotask(() => {
        nextTick(() => {
          initBicAutocompleteElements()
        })
      })
    })
  }

  document.addEventListener('livewire:init', () => {
    initBicAutocompleteElements()
  })

  window.Livewire.hook('commit', ({ succeed }) => {
    succeed(() => {
      delayBicAutocompleteElementsInit()
    })
  })

  document.addEventListener('livewire:navigated', () => {
    delayBicAutocompleteElementsInit()
  })

  initBicAutocompleteElements()
  loadBics()
}
